import {Inject, Injectable} from 'ng-metadata/core';


import {RequestFromService} from './requestForms.service';
import {MappingTablesCache} from '../../../../../mappingTablesCache/mappingTablesCache.service';
import {FormBuilderService, FormBuilderEnums} from '../../../../../infra/formBuilder/formBuilder.service';
import {IGeneralAlertMsg} from '../../../../../infra/widgets/alerts/alertMsg.interface';
import {AlertFactory,ALERT_MSG_TYPE} from '../../../../../infra/widgets/alerts/alertFactory.service';
import {PrimoResponse} from '../../../../../infra/dataStructures/PrimoResponses/ils.interface';
import {OpacService} from '../opac.service';
import { LocationsService } from '../locations/locations.service';
import {
    getInstitutionCode,
    getRequestItemAvailabilityCheckTimeout,
    getFindItemLevelDescriptionsTimeout
} from "../../../../../appConfig/appConfigForward";
import {getInstitutionCode, getRequestItemAvailabilityCheckTimeout, getFindItemLevelDescriptionsTimeout, getRequestDefaultFormat} from "../../../../../appConfig/appConfigForward";
import {JwtUtilService} from "../../../../../security/jwtUtil.service";
import {Observable} from 'rxjs/observable';
import {Subject} from "rxjs/Subject";


var angular:angular.IAngularStatic =  require('angular');
const filter = require('lodash/filter');
const split = require('lodash/split');
const foreach = require('lodash/forEach');
const _get = require('lodash/get');
const _clone = require('lodash/clone');


@Injectable()

export class RequestService {

    public updateForm = angular.bind(this, this.updateFormUnbound);

    private _formFields = [];   //service form
    private _form = [];         //current form
    private _formData = {};     //form fields data
    private _ilsData;
    private _service : PrimoResponse.Ils.IRequestService;
    private _ilsApiId : string;
    private _formchanged: boolean;
    private _requestIsLoading: boolean;
    private _displayErrorMessage: boolean;
    private _reqAlert :IGeneralAlertMsg;

    private ilsDataPerService = {
        'HoldRequest': (data) => {return this.getDataByService('HoldRequest', data);},
        'ILL': (data) => {return this.getDataByService('ILL', data);},
        'Recall': (data)=> {return this.getDataByService('Recall', data);},
        'PhotocopyRequest': (data)=> {return data['services-arr'].services;},
        'CallSlip': (data) =>  {return this.getDataByService('CallSlip', data);},
        'UBRequest': (data) => {return this.getDataByService('ubrequest', data);},
        'ShortLoan': (data) => {return this.getDataByService('ShortLoan', data);},
        'AlmaRequest': (data) => {return this.getDataByService('AlmaRequest', data);},
        'AlmaDigitization': (data) => {return this.getDataByService('AlmaDigitization', data);},
        'AlmaPurchaseRequest': (data) => {return this.getDataByService('AlmaPurchaseRequest', data);},
        'AlmaResourceSharing': (data) => {return this.getDataByService('AlmaResourceSharing', data);},
        'AlmaRequestAnyItem': (data) => {return this.getDataByService('AlmaRequestAnyItem',data);},
        'AlmaRequestOther': (data) => {return this.getDataByService('AlmaRequestOther', data);},
        'AlmaDigitizationOther': (data) => {return this.getDataByService('AlmaDigitizationOther', data);},
        'AlmaGeneralDigitization': (data) => {return this.getDataByService('AlmaGeneralDigitization', data);},
        'AlmaItemRequest': (data) => {return this.getDataByService('AlmaRequest', data);},
        'AlmaItemDigitization': (data) => {return this.getDataByService('AlmaDigitization', data);}
    };

    private mappingTablePerService = {
        'HoldRequest': this.mappingTablesCache.tables.HOLD_OPTIONAL_REQUEST_PARAMETERS,
        'ILL': this.mappingTablesCache.tables.ILL_OPTIONAL_REQUEST_PARAMETERS,
        'Recall': this.mappingTablesCache.tables.RECALL_OPTIONAL_REQUEST_PARAMETERS,
        'PhotocopyRequest': this.mappingTablesCache.tables.PHOTOCOPY_OPTIONAL_REQUEST_PARAMETERS,
        'CallSlip': this.mappingTablesCache.tables.CALL_SLIP_OPTIONAL_REQUEST_PARAMETERS,
        'UBRequest': this.mappingTablesCache.tables.UB_OPTIONAL_REQUEST_PARAMETERS,
        'AlmaRequest': this.mappingTablesCache.tables.HOLD_BOOKING_OPTIONAL_REQUEST_PARAMETERS,
        'AlmaDigitization': this.mappingTablesCache.tables.DIGITIZATION_OPTIONAL_REQUEST_PARAMETERS,
        'AlmaPurchaseRequest': this.mappingTablesCache.tables.PURCHASE_REQUEST_OPTIONAL_PARAMETERS,
        'AlmaResourceSharing': this.mappingTablesCache.tables.RESOURCE_SHARING_REQUEST_PARAMETERS,
        'AlmaRequestAnyItem': this.mappingTablesCache.tables.HOLD_BOOKING_OPTIONAL_REQUEST_PARAMETERS,
        'AlmaRequestOther': this.mappingTablesCache.tables.HOLD_BOOKING_OPTIONAL_REQUEST_PARAMETERS,
        'AlmaDigitizationOther': this.mappingTablesCache.tables.DIGITIZATION_OPTIONAL_REQUEST_PARAMETERS,
        'AlmaGeneralDigitization': this.mappingTablesCache.tables.DIGITIZATION_OPTIONAL_REQUEST_PARAMETERS,
        'AlmaItemRequest': this.mappingTablesCache.tables.HOLD_BOOKING_OPTIONAL_REQUEST_PARAMETERS,
        'AlmaItemDigitization': this.mappingTablesCache.tables.DIGITIZATION_OPTIONAL_REQUEST_PARAMETERS
    };
    private _newFormObservable: Subject<any>;
    private _isCheckAvailabilityEnabled: boolean;
    private _isCheckAvailabilityMandatory: boolean;
    private _isBookFindItemDescriptionsEnabled: boolean;
    private _isArticleFindItemDescriptionsEnabled: boolean;

//    private additionalParamsPerService= {
//        'HoldRequest': this.getHoldAdditionalParams,
//        'ILL': this.getILLAdditionalParams,
//        'Recall': this.getRecallAdditionalParams,
//        'PhotocopyRequest': this.getPhotocopyAdditionalParams,
//        'CallSlip': this.getCallSlipAdditionalParams,
//        'UBRequest': this.getUBAdditionalParams
//    }

    get isCheckAvailabilityEnabled(){
        return this._isCheckAvailabilityEnabled;
    }

    get isCheckAvailabilityMandatory() {
        return this._isCheckAvailabilityMandatory;
    }

    get isArticleFindItemDescriptionsEnabled(){
        return this._isArticleFindItemDescriptionsEnabled
            && this._formData.citationType == 'CR'
    }
    set isArticleFindItemDescriptionsEnabled(isArticleFindItemDescriptionsEnabled){
        this._isArticleFindItemDescriptionsEnabled = isArticleFindItemDescriptionsEnabled;
    }

    get isBookFindItemDescriptionsEnabled(){
        return this._isBookFindItemDescriptionsEnabled
            && this._formData.citationType == 'BK'
    }
    set isBookFindItemDescriptionsEnabled(isBookFindItemDescriptionsEnabled){
        this._isBookFindItemDescriptionsEnabled = isBookFindItemDescriptionsEnabled;
    }

    get requestIsLoading(){
        return this._requestIsLoading;
    }

    set requestIsLoading(requestIsLoading){
        return this._requestIsLoading = requestIsLoading;
    }
    get displayErrorMessage(){
        return this._displayErrorMessage;
    }

    set displayErrorMessage(displayErrorMessage){
       this._displayErrorMessage = displayErrorMessage;
    }

    private getHoldAdditionalParams(item){
        return {};
    }

    private getILLAdditionalParams(item){
        return {};
    }

    private getRecallAdditionalParams(item){
        return {};
    }

    private getPhotocopyAdditionalParams(item){
        return {};
    }

    private getCallSlipAdditionalParams(item){
        return {};
    }

    private getUBAdditionalParams(item){
        let sourcedbandrecordid;

        if (angular.isArray(item.pnx.control.sourcedbandrecordid)) {
           sourcedbandrecordid = item.pnx.control.sourcedbandrecordid.map((item, index, array) => this.handleDedup(item));
        } else {
            sourcedbandrecordid = this.handleDedup(item.pnx.control.sourcedbandrecordid);
        }

        return {ils_db_id_record_id: sourcedbandrecordid};
    }

    private getShortLoanAdditionalParams(item){
         return {};
    }

    private getAlmaDigitizationAdditionalParams(item){
         return {};
    }

	private getAlmaRequestAdditionalParams(item){
         return {};
    }

    private getAlmaPurchaseRequestAdditionalParams(item){
         return {};
    }

    private getAlmaResourceSharingAdditionalParams(item) {
        if (_get(item, 'pnx.display.type[0]') === 'book_chapter'
        || _get(item, 'pnx.control.recordtype[0]') === 'book_chapter'
        || (_get(item, 'pnx.addata.format[0]') === 'book' && _get(item,'pnx.addata.genre[0]') === 'bookitem')
        || (_get(item, 'pnx.addata.format[0]') === 'info:ofi/fmt:kev:mtx:book' && 
            (_get(item, 'pnx.addata.genre[0]') === 'bookitem' || _get(item, 'pnx.addata.atitle')))) {
            return {bookchapter: true};
        }
        return {bookchapter: false};
    }

    private getAlmaRequestAnyItemAdditionalParams(item){
         return {};
    }

    private handleDedup(value) {
        let splitted = split(value, '$$V');
        if (splitted.length > 1) {
            value = splitted[1];
        }
        splitted = split(value, '$$');
        if (splitted.length > 1) {
            value = splitted[0];
        }
        return value;
    }


    constructor(@Inject('$translate') private $translate: ng.translate.ITranslateService,
    			private requestFromService : RequestFromService,
                private mappingTablesCache : MappingTablesCache,
                private formBuilderService : FormBuilderService,
                private alertService:AlertFactory,
                @Inject('restBaseURLs') private restBaseURLs :any,
                private opacService : OpacService,
                private locationsService: LocationsService,
                @Inject('$http') private $http: ng.IHttpService,
                private jwtUtilService: JwtUtilService) {
        this._newFormObservable = new Subject();
        this._reqAlert = this.alertService.create(ALERT_MSG_TYPE.REQUEST) as IGeneralAlertMsg;
    	this._isCheckAvailabilityEnabled= this.mappingTablesCache.findByProperties(
            this.mappingTablePerService.AlmaResourceSharing, {source2: 'itemAvailability', target: 'Yes'}).length > 0;
        this._isCheckAvailabilityMandatory = this.mappingTablesCache.findByProperties(
            this.mappingTablePerService.AlmaResourceSharing, {source2: 'itemAvailability', source5: 'Yes'}).length > 0;

        this._isBookFindItemDescriptionsEnabled = this.mappingTablesCache.findByProperties(
            this.mappingTablePerService.AlmaResourceSharing, {source2: 'findBookItemsDescriptions', target: 'Yes'}).length > 0;
        this._isArticleFindItemDescriptionsEnabled =  this.mappingTablesCache.findByProperties(
                this.mappingTablePerService.AlmaResourceSharing, {source2: 'findArticleItemsDescriptions', target: 'Yes'}).length > 0;
    }

    public setMessages(html){
        this._reqAlert.show(html);
    }

    public getHtml(isLoggedIn:boolean, label) :string{

        let html = '';
        if (!isLoggedIn) {
            html =

                '<span class="bar-text margin-right-small" translate="nui.request.signin"></span>' +
                '<prm-authentication [is-logged-in]="ctrl.userName().length > 0" flex="none"></prm-authentication>';

        } else if(label) {
            html =

                '<span class="bar-text margin-right-small" translate="' + label + '"></span>' ;

        }
        return html;
    }


    /* getters / setters */
    get formFields() {
        return this._formFields;
    }

    set formFields(formFields) {
        this._formFields = formFields;
    }

    get form() {
        return this._form;
    }

    set form(form) {
        this._form = form;
    }

    get formData() {
        return this._formData;
    }

    set formData(formData) {
        this._formData = formData;
    }

    get ilsData() {
        return this._ilsData;
    }

    set ilsData(ilsData) {
        this._ilsData=ilsData;
    }

    get formchanged() {
        return this._formchanged;
    }

    set formchanged(formchanged) {
        this._formchanged = formchanged;
    }

    get service() {
        return this._service;
    }

    set service(service) {
        this._service = service;
    }

    get ilsApiId() {
        return this._ilsApiId;
    }

    set ilsApiId(ilsApiId) {
        this._ilsApiId = ilsApiId;
    }

    get reqAlert() :IGeneralAlertMsg {
        return this._reqAlert;
    }

    get newFormObservable(){
        return this._newFormObservable;
    }

    public setupNewForm(service, res, isResetCurrentForm = false) {
        this.form = []; //reset form
        this.formData = {}; //reset data

        this.ilsData = res;

        this.service = service;

        this.formFields = this.requestFromService.getFormFields(this.service);

        this.updateForm({service:service});

        if (!isResetCurrentForm){
            //fire observable that will let subscribers know that a new form is opened
            this._newFormObservable.next('newForm');
        }

    }

    public updateFormUnbound(params) {

        if (!params) { //create an empty one...
            params = {};
        }

        if (params.service) { //update service field
            this.service = params.service;
        }

        this.form = this.parseFields(this.service, params);

    }

    public isDisplayFormDescription(serviceType) {
        switch (serviceType) {
            case 'AlmaDigitization'   :
                return this.mappingTablesCache.findByProperties(this.mappingTablePerService.AlmaDigitization, {source2: 'formDescription', target: 'Yes'}).length > 0;
            case 'AlmaItemDigitization' :
                return this.mappingTablesCache.findByProperties(this.mappingTablePerService.AlmaDigitization, {source2: 'formDescription', target: 'Yes'}).length > 0;
            case 'AlmaDigitizationOther'   :
                return this.mappingTablesCache.findByProperties(this.mappingTablePerService.AlmaDigitizationOther, {source2: 'formDescription', target: 'Yes'}).length > 0;
            case 'AlmaGeneralDigitization'   :
                return this.mappingTablesCache.findByProperties(this.mappingTablePerService.AlmaGeneralDigitization, {source2: 'formDescription', target: 'Yes'}).length > 0;
            case 'AlmaPurchaseRequest'   :
                return this.mappingTablesCache.findByProperties(this.mappingTablePerService.AlmaPurchaseRequest, {source2: 'formDescription', target: 'Yes'}).length > 0;
            case 'AlmaRequest'  :
                return this.mappingTablesCache.findByProperties(this.mappingTablePerService.AlmaRequest, {source2: 'formDescription', target: 'Yes'}).length > 0;
            case 'AlmaItemRequest'  :
                return this.mappingTablesCache.findByProperties(this.mappingTablePerService.AlmaRequest, {source2: 'formDescription', target: 'Yes'}).length > 0;
            case 'AlmaRequestAnyItem'   :
                return this.mappingTablesCache.findByProperties(this.mappingTablePerService.AlmaRequestAnyItem, {source2: 'formDescription', target: 'Yes'}).length > 0;
            case 'AlmaRequestOther'   :
                return this.mappingTablesCache.findByProperties(this.mappingTablePerService.AlmaRequestOther, {source2: 'formDescription', target: 'Yes'}).length > 0;
            case 'AlmaResourceSharing'  :
                return this.mappingTablesCache.findByProperties(this.mappingTablePerService.AlmaResourceSharing, {source2: 'formDescription', target: 'Yes'}).length > 0;
            default :
                return false;
        }
    }

    /* private functions */
    private parseFields(service,params) {
        if (!this.formFields) {
            return [];
        }

        if (params.trigger) {
            foreach(this.formFields, (field) => {
                if (field.disabled) {
                    this.formData[field.name] = undefined;
                    field.disabled = false;
                }
            });
        }

        let mappedFormFields = this.formFields.map((value, index, array1) => this.parseItem(service, value, params)).filter(this.filterEmpty);
        if(mappedFormFields && mappedFormFields.length >0 && mappedFormFields[0].order){
            return mappedFormFields.sort(function(field1, field2) {
                   if(field1.order && field2.order){
                      return parseFloat(field1.order) - parseFloat(field2.order);
                   }else if(field1.order && !field2.order){
                           return -1;
                   }else if(!field1.order && field2.order){
                           return 1;
                   }else{
                      return 0;
                   }
               });
        }else{
            return mappedFormFields;
        }
    }

    //item - field
    private parseItem(service, field, params) {

        if (!field) {
            return {};
        }

        this.updateFieldFromMappingTable(service, field);

        let curIlsData = this.getIlsDataForField(service, field);

        if ((field.name !== params.trigger || field.duplicateOf === params.trigger) && field.populator && field.populator.func && curIlsData) {
            field.populator.func(field, this.formFields, this.formData ,curIlsData);

			if (!field.populator.allowEmptyOptions && (!field.options || field.options.length === 0)) {//field multi select's options are empty
                return {};
            }
        }


        this.requestFromService.getForm(service).handleField(field, this.formFields,
            this.formData, this.ilsDataPerService[service.type](this.ilsData),
            params);
         //let x = {updateForm : this.updateForm.bind}
        //handle events
        if (field.events) {
            field.events.onChange = this.updateForm;
            field.events.onClick = this.updateForm;
            field.events.params = {service:service, trigger:field.name};
            if(field.name === 'requestType'){
                field.events.onClick = (params)=>{
                    foreach(params.formFields, (field1) => {
                        if(field1.name !== 'requestType'){
                            params.formData[field1.name] = undefined;
                            field1.disabled = false;
                            }
                    });
                    this.updateForm();
                    };
                field.events.params = {formData:this.formData,formFields:this.formFields};
                }

        }

        return field;
    }

    private getIlsDataForField(service, field) {
        if (field.path === FormBuilderEnums.ROOT) {
            return this.ilsData;
        } else if (this.ilsDataPerService[service.type]) {
            return this.ilsDataPerService[service.type](this.ilsData);
        } else {
            return; //undefined
        }
    }

    private filterEmpty(e) {
        return e.name;
    }

    private hideField(field: any) {
        if (!field.saveFormField) {
            field.saveFormField = {};
        }
        field.saveFormField.uiType = field.uiType;
        field.uiType = FormBuilderEnums.UI_TYPE.HIDDEN;
    }

    private updateFieldFromMappingTable(service, field) {
        if (!this.mappingTablePerService[service.type]) {
            return;
        }

        let fieldKey = field.key;
        
        /* In case the field is description we need to use these codes and not the field key. */
        if(service.type === 'AlmaResourceSharing'){
            if(fieldKey === 'articleDescription'){
                fieldKey = 'findArticleItemsDescriptions';
            }
            else if(fieldKey === 'bookDescription'){
                fieldKey = 'findBookItemsDescriptions';
            }
        }

        let mappingTable = this.mappingTablesCache.findByProperties(this.mappingTablePerService[service.type], {source2: fieldKey});

        if (!mappingTable || mappingTable.length === 0) {
            if(mappingTable.length === 0 && fieldKey === "allowOtherLibrary"){
                this.hideField(field);
            }
            return;
        }

        let mappingTableConfig;

        if(service.type === 'AlmaResourceSharing' && mappingTable.length > 1){
            mappingTable = mappingTable.filter(this.filterMappingTableRowsByCitationType(this._formData));
        }

        mappingTableConfig = mappingTable[0];

        //hide field
        if (mappingTableConfig.target === 'No') {
            this.hideField(field);
        }else{
            //restore field uiType incase it was
            if(field.saveFormField && field.uiType === FormBuilderEnums.UI_TYPE.HIDDEN && field.saveFormField.uiType
            && _get(field,'populator.params.singleValueBehaviour') !== FormBuilderEnums.UI_TYPE.HIDDEN){
                field.uiType = field.saveFormField.uiType;
            }
        }

        //mandatory setting
        if (mappingTableConfig.source5) {
            if(fieldKey === 'email') {
                if (this._formData.format == 'DIGITAL') {
                    field.mandatory = true;
                } else {
                    const alternativeLocationEmail = this.formFields.filter(e => e.key === 'alternativeLocationEmail');
                    if (alternativeLocationEmail.length > 0 && alternativeLocationEmail[0].options && alternativeLocationEmail[0].options.length > 1 && this._formData.alternativeLocationEmail && this._formData.alternativeLocationEmail === 'alternativeEmail') {
                        field.mandatory = true;
                    } else {
                        field.mandatory = false;
                    }
                }
            } else {
                field.mandatory = (mappingTableConfig.source5 === 'Yes' || mappingTableConfig.source5 === 'true') ;
            }
        }

        let sectionsMap = this.requestFromService.getSectionsMap(this.service);
        if(sectionsMap){
           if(fieldKey === 'line1' || fieldKey === 'line2' || fieldKey === 'line3' || fieldKey === 'line4'){
               let saveMappingTableConfig = mappingTableConfig;
               mappingTable = this.mappingTablesCache.findByProperties(this.mappingTablePerService[service.type], {source2: 'alternativeLocationAddress'});
               if(mappingTable.length > 1){
                   mappingTable = mappingTable.filter(this.filterMappingTableRowsByCitationType(this._formData));
               }
               mappingTableConfig = mappingTable[0];
               field.order = sectionsMap[mappingTableConfig.source3] * 100 + parseInt(mappingTableConfig.source4,10) + parseInt(saveMappingTableConfig.source4,10);
           }else if(fieldKey === 'email'){
               let saveMappingTableConfig = mappingTableConfig;
               mappingTable = this.mappingTablesCache.findByProperties(this.mappingTablePerService[service.type], {source2: 'alternativeLocationEmail'});
               if(mappingTable.length > 1){
                   mappingTable = mappingTable.filter(this.filterMappingTableRowsByCitationType(this._formData));
               }
               mappingTableConfig = mappingTable[0];
               field.order = sectionsMap[mappingTableConfig.source3] * 100 + parseInt(mappingTableConfig.source4,10) + parseInt(saveMappingTableConfig.source4,10);
           }else{
               field.order = sectionsMap[mappingTableConfig.source3] * 100 + parseInt(mappingTableConfig.source4,10);
           }
        }


    }

    private getDataByService(serviceType :string,data) {
        let array = filter(data['services-arr'].services , (el) => { //filter data for selected request only (i.e. hold)
            return el['type-name'] === serviceType || el['service-name'] === serviceType;
        });

        return array ? array : [];
    }

    public getServicesAdditionalParams( item){
        //return this.additionalParamsPerService[service](item);
        return {
            'HoldRequest': this.getHoldAdditionalParams(item),
            'ILL': this.getILLAdditionalParams(item),
            'Recall': this.getRecallAdditionalParams(item),
            'PhotocopyRequest': this.getPhotocopyAdditionalParams(item),
            'CallSlip': this.getCallSlipAdditionalParams(item),
            'UBRequest': this.getUBAdditionalParams(item),
            'ShortLoan': this.getShortLoanAdditionalParams(item),
            'AlmaDigitization': this.getAlmaDigitizationAdditionalParams(item),
            'AlmaPurchaseRequest': this.getAlmaPurchaseRequestAdditionalParams(item),
            'AlmaRequest': this.getAlmaRequestAdditionalParams(item),
            'AlmaResourceSharing': this.getAlmaResourceSharingAdditionalParams(item),
            'AlmaRequestAnyItem': this.getAlmaRequestAnyItemAdditionalParams(item),
            'AlmaDigitizationOther': this.getAlmaDigitizationAdditionalParams(item),
            'AlmaGeneralDigitization' : this.getAlmaDigitizationAdditionalParams(item),
            'AlmaRequestOther': this.getAlmaRequestAdditionalParams(item),
            'AlmaItemDigitization' : this.getAlmaDigitizationAdditionalParams(item),
            'AlmaItemRequest'   : this.getAlmaRequestAdditionalParams(item)
        }
    }

    private filterMappingTableRowsByCitationType = function(formData) {
      return function(row) {
        if(row.source3){
             if(row.source3 ==='book' && formData.citationType ==='BK'){
                return true;
              }else if(row.source3 ==='article' && formData.citationType ==='CR'){
                 return true;
              }else{
                 return false;
              }
          }
          return false;
      }
  }

  public checkAvailability(){
        let params = _clone(this.formData);
        let userId = this.jwtUtilService.getDecodedToken()['user'];
        params['userId'] = userId;
        let timeout = getRequestItemAvailabilityCheckTimeout();
        return this.$http.get(this.restBaseURLs.ILSServicesBaseURL + '/institutionCode/' + getInstitutionCode() + '/isItemAvailableForRequest',
            {params: params, timeout: timeout});
  }

    public findItemLevelDescriptions(){
        let params = _clone(this.formData);
        let userId = this.jwtUtilService.getDecodedToken()['user'];
        params['userId'] = userId;
        let timeout = getFindItemLevelDescriptionsTimeout();
        return this.$http.get(this.restBaseURLs.ILSServicesBaseURL + '/institutionCode/' + getInstitutionCode() + '/findItemLevelDescriptions',
            {params: params, timeout: timeout});
    }


    public getDigitalDefaultOwnerAndPickupInformation() {
        let params = _clone(this.formData);
        let userId = this.jwtUtilService.getDecodedToken()['user'];
        params['userId'] = userId;
        return this.$http.get(this.restBaseURLs.ILSServicesBaseURL + '/calcDigitalDefaultOwner/AlmaResourceSharing?institution=' + getInstitutionCode(),
            {params: params});
    }
}

//put here all angular1 modules the service is using
export default [];



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/request.service.ts